import React, { useEffect, useState } from "react";

import { Card, Col, Row } from "react-bootstrap";

import ProductItem from "../../../components/products/ProductItem";
import NothingToShow from "../../../components/general/NothingToShow";
import BoxLoading from "../../../components/general/BoxLoading";
import Pagination from "../../../components/general/Pagination";

import { getMyProducts } from "../../../redux/features/plan/actions";
function MyIndicators() {
  const [loading, setLoading] = useState(false);

  const [products, setProducts] = useState({
    data: [],
    lastPage: 1,
    currentPage: 1,
    from: 1,
    total: 1,
  });

  /**
   * Change Like
   * @param {index} payload
   */
  const changeLikeInfo = (index) => {
    let data = { ...products };
    if (!data.data[index].myLike) {
      ++data.data[index].totalLikes;
    } else {
      --data.data[index].totalLikes;
    }
    data.data[index].myLike = !data.data[index].myLike;

    setProducts(data);
  };

  /**
   * Get Products
   */
  const get_products = async (page) => {
    // start loading
    setLoading(true);

    // set variable
    let param = new URLSearchParams();
    param.set("page", page);
    param.set("status", "paid");

    // request
    await getMyProducts(param).then((res) => {
      if (res) {
        setProducts({
          data: res.products,
          lastPage: res.lastPage,
          currentPage: res.currentPage,
          total: res.total,
        });
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_products(1);
  }, []);

  return (
    <div className="indicators">
      {products.data.length ? (
        <>
          <Row>
            {products.data.map((item, index) => (
              <Col sm={6} lg={4} xxl={3} key={item.id}>
                <ProductItem
                  mine
                  item={item}
                  index={index}
                  changeLikeInfo={changeLikeInfo}
                />
              </Col>
            ))}
          </Row>
          {products.lastPage > 1 && (
            <div className="pagination-box mb-5">
              <small>
                Showing
                <span className="fw-bolder mx-1">25</span>of
                <span className="fw-bolder mx-1">{products.total}</span>Products
              </small>
              <Pagination
                currentPage={products.currentPage - 1}
                lastPage={products.lastPage}
                changePage={(page) => get_products(page.selected + 1)}
              />
            </div>
          )}
        </>
      ) : (
        <Card>
          <Card.Body>
            <NothingToShow text={loading ? "Loading..." : "Nothing to show"} />
            {loading && <BoxLoading />}
          </Card.Body>
        </Card>
      )}
    </div>
  );
}

export default MyIndicators;
